/* eslint-disable quotes */
// Indonésio
export const indonesio = {
  start: "Mulai",
  configurations: "Pengaturan",
  ramdom: "Mode putar acak",
  vibration: "Getaran :",
  startgame: "Permainan dimulai",
  save: "Simpan",
  delete: "Menghapus",
  update: "Pembaruan",
  lets: "Mari bermain",
  permanentbuy: "Pembelian Permanen",
  signature: "Langganan bulanan",
  signatureano: "Langganan tahunan",
  small:
    "Di sini Anda bisa menggunakan nama asli Anda... atau nama panggilan:)",
  text1: "Dapatkan akses premium dan jamin semua pembaruan",
  text2:
    "Dengan berlangganan, Anda dapat mengakses versi Premium kapan pun Anda mau",
  gender: "Jenis kelamin",
  male: "Pria  ",
  female: "Perempuan",
  ambos: "Keduanya",
  fechar: "Tutup",
  sexualorientation: "Orientasi seksual",
  heterosexual: "Heteroseksual",
  homosexual: "Homoseksual",
  bisexual: "Biseksual",
  chooseavatar: "Pilih avatar Anda",
  Participants: "Partisipan",
  participant: "Pendaftaran Peserta",
  name: "Nama",
  choosecategory: "Pilih kategori",
  categories: "Kategori",
  light: "Cahaya",
  preliminary: "Pendahuluan",
  oral: "Lisan",
  anal: "Seks anal",
  hot: "Panas",
  extreme: "Ekstrim",
  vd: "Kebenaran ?",
  dare: "Tantangan ?",
  truth: "Kebenaran",
  time: "Waktu",
  createMyChallenges: "Buat Tantangan Saya",
  chosen: "Terpilih",
  text3: "Biarkan cinta mengalir dalam diri Anda!",
  text4: "Bersiaplah untuk hidup secara intens",
  close: "Menutup",
  sele: "Pilih opsi",
  dev: "Dikembangkan oleh Dev12BR",
  game: "Permainan",
  get: "Comprar - R$ 34,99",
  sign: "Assinar - R$ 5,99",
  next: "BERIKUTNYA",
  config1: "Mengapa saya harus membeli versi Premium?",
  config2: "Kategori eksklusif dan lebih dari 800 tantangan baru",
  config3: "Tidak ada iklan",
  config4: "Pilih avatar untuk meningkatkan",
  config5: "Ciptakan tantangan Anda sendiri ",
  config6: "Anda mendukung pengembangan game",
  config7: "Mengapa permainan ini memiliki biaya?",
  config8:
    "Untuk mengembangkan permainan, Anda perlu waktu! :) Dengan cara ini Anda mendukung permainan, membantu kami untuk selalu meningkatkan dan memperbarui permainan.",
  config9: "Buat dan edit tantangan Anda sendiri",
  age: `Game ini hanya untuk orang dewasa, jadi Anda harus berusia minimal 18 tahun. Dengan memilih "Ya", Anda menyetujui ketentuan penggunaan dan kebijakan Privasi. 
  
      Game ini cocok untuk pasangan, jadi Anda harus bermain dengan setidaknya satu pasangan. 
      
      Ini bukan aplikasi kencan, tetapi cara untuk bermain dengan pasangan Anda.
      `,
  config10: "Kategori eksklusif",
  config11: "+ 800 tantangan baru",
  assessment:
    "Silakan beri nilai dengan menambahkan komentar tentang aplikasi ini. Umpan balik Anda sangat penting bagi kami untuk menjaga permainan sebaik mungkin.",
  agree: "Ya, saya berusia di atas 18 tahun",
  noAgree: "Tutup Aplikasi",
  apoio1: "Dukung pengembangan dengan berlangganan versi Premium :)",
  apoio2: "Jangan lupa untuk menilai aplikasi di toko S2",
  apoio3: "Dapatkan akses ke semua fitur eksklusif dalam versi Premium",
  apoio4: "Singkirkan banner ini - Beli versi Premium",
  version: "Versi Premium",
  version1: "Versi Premium",
  alert1: "Daftarkan pengguna untuk bermain",
  alert2: "Daftarkan setidaknya satu pengguna lagi untuk bermain",
  alert3: "Pilih setidaknya satu kategori",
  alert4: `🔥 Ada peserta tanpa mitra. Memiliki setidaknya dua peserta untuk setiap jenis kelamin 🔞. 
          
  Contoh: Dua orang heteroseksual, atau 2 orang homoseksual.`,
  tituloAlert1: "⚠️ Permainan akan segera dimulai 😜",
  tituloAlert2:
    "⚠️ Sayang sekali 😬, Anda tanpa internet 📶. Nyalakan internet pada perangkat Anda dan beli paket langganan, atau paket utama. Dan berbahagialah😘.",
  parser: "Tidak ada mitra",
  premiumImages: "Menjadi Premium dan dapatkan akses ke lebih banyak avatar",
  duvidas: "Pertanyaan atau Saran - Tantangan Pedas",
  description: "Halo, pertanyaan atau saran saya adalah :",
  texto99:
    "Jika Anda memiliki masalah, pertanyaan, atau saran, silakan kirimkan email kepada kami dengan mengeklik tombol ini di bawah. Kami menantikan untuk berbicara dengan Anda!",
  send: "Kirim",
  contact: "Kontak",
  botaoApple: "Kembalikan pembelian",
  alertCompra: "Pembelian Anda sedang dipulihkan",
  NotPurchase: "Anda tidak memiliki pembelian",
  notPurchase2:
    "Tautan ini hanya untuk pengguna yang telah membeli pembelian sebelumnya dan ingin memulihkan ke perangkat baru.",
  termOfPotitic: "Ketentuan Penggunaan, dan Kebijakan Privasi",
  alertDeuErrado: "Ada yang tidak beres :(",
  alertDeuErrado2: "Isi semua informasi",
  alertNome: "Isi kolom: Nama",
  options: "Opsi",
  optionsTitle: "Opsi",
  gradualGame: "Permainan Bertahap",
  textoCaixa:
    "Dengan mengaktifkan pilihan ini, tantangan akan bertahap, yaitu, dari yang paling ringan hingga yang paling ekstrem menurut pilihan Anda.",
  comoJogar: "Bagaimana cara bermainnya? 🤔",
  avalie: "Evaluasi",
  novaCategoria: "Kategori saya",
  alterLanguage: "Ubah Bahasa?",
  textLanguage: "Apabila mengubah bahasa, aplikasi akan dimulai ulang",
  textLanguage1: "Ubah Bahasa",
  cancel: "Batalkan",
  languages: "Bahasa",
  email: "@email ✉️",
  deletCat: "Hapus kategori",
  textDeletCat:
    "Dengan menghapus kategori ini, tantangan dalam kategori ini akan dihapus. Setelah tindakan ini, tidak bisa lagi dibatalkan.",
  deletDes: "Hapus tantangan",
  textDeletDes:
    "Setelah menghapus tantangan, tindakan ini tidak bisa lagi dibatalkan.",
  desafio: "Daftarkan Tantangan Baru",
  desafiotexto: "Tantangan",
  textoeditDesafio: "Siapa yang bisa melakukan itu?",
  textEmquem: "Pada siapa?",
  nome: "Nama",
  inicio: "Memulai permainan",
  inicio2:
    "ADengan menekan tombol ini, Anda akan dibawa ke layar pendaftaran pemain 👥.",
  inicio3: "Permainan akan segera dimulai 🎲",
  inicio4: "Berikutnya",
  inicio5: "Penyesuaian dan pengaturan",
  inicio6: `Penyesuaian seperti:  
    
  - Tantangan progresif
  - Ubah bahasa tantangan 
  - Ciptakan tantangan 
  - Mendukung 
  - Antara lain.`,
  inicio7: "Akhir",
  inicio8: `Menjadi Premium dan dapatkan akses ke:
  
  - 450 lebih banyak tantangan baru 😎
  
  - Karakter eksklusif 🦸♀️ 🧑🚒
  
  - Ciptakan tantangan Anda sendiri 📝
  
  - Terus perbarui permainan ✅
  
  - Dan masih banyak lagi 😍`,
  inicio9: "Bantuan",
  inicio10: "Selamat datang di permainan Spicy Challenges 🌶",
  inicio11:
    "Lihat betapa mudahnya memainkan dan menavigasi menu dalam waktu kurang dari 30 detik 😎.",
  inicio12: "Lihat tutorial 👍🏼",
  inicio13: "Saya tidak ingin 👎🏼",
  inicio14: `Untuk memulai permainan, Anda perlu menambahkan setidaknya dua (2) pemain 😀.
                
  Menekan tombol yang ditunjukkan di atas 👆
    
  Setiap kali Anda menambahkan pengguna baru, tekan tombol yang sama 😘`,
  cadastrarCategory: "Daftar Kategori",
  inicio15: "Membuat kategori baru",
  inicio16:
    "Langkah 1 : Tekan tombol dengan tanda + yang terletak di bagian bawah layar ini. Setelah menekan, sebuah jendela akan muncul bagi Anda untuk memasukkan kategori baru Anda.",
  inicio17: "Langkah 2: Masukkan kategori baru Anda dan klik simpan",
  inicio18:
    "Langkah 3: Untuk mengedit kategori ini atau untuk MENAMBAH tantangan dalam kategori, klik di atasnya.",
  inicio19:
    "Langkah 4: Pada layar berikutnya, menekan tombol yang ditunjukkan dengan tanda panah ⬆️ akan membuka jendela untuk mengedit kategori baru Anda.",
  inicio20:
    "Langkah 5: Pada layar berikutnya, dengan menekan tombol yang ditunjukkan dengan tanda panah ⬆️, Anda akan menghapus kategori tersebut.",
  inicio21:
    "Langkah 1: Tekan tombol di bawah ini untuk menambahkan tantangan baru ke kategori ini",
  inicio22: "Menciptakan tantangan baru",
  inicio23:
    "Langkah 2: Klik pada setiap item yang dilingkari untuk mengetahui secara rinci setiap bidang register",
  inicio24: "Teks tantangan",
  inicio25: `Tulis tantangan sesuai keinginan Anda, dan agar nama pemain ditampilkan dalam tantangan, cukup tekan tombol merah di bawah ini.
      
  Ini akan menambahkan karakter berikut {nome}. 
  
  ** JANGAN MENGUBAH KARAKTER-KARAKTER INI ** Karena agar nama yang ditampilkan sesuai, maka perlu seperti yang dijelaskan di bawah ini ⬇️⬇️⬇️⬇️⬇️⬇️
  
  Tantangan: Mencium leher {nome}`,
  inicio26: "Siapa yang bisa melakukan, dan siapa yang bisa menerima",
  inicio27: `Pilih "Both" jika tantangan dapat dilaksanakan dan diterima oleh peserta dari "kedua" jenis kelamin.
    
  Jika tantangan diarahkan pada satu jenis kelamin, cukup pilih yang diinginkan.
  `,
  inicio28: "Menambahkan waktu untuk tantangan",
  inicio29:
    'Jika tantangan Anda memiliki waktu, cukup seret "range" di bawah ini, dan nilainya akan ditampilkan di atas. Setelah waktu habis dalam tantangan, suara akan diputar untuk memberi tahu Anda bahwa tantangan sudah berakhir.',
  aviso12: `Di sini Anda tinggal membuat kategori!
      
  Untuk menambahkan tantangan cukup klik tombol kategori yang baru Anda buat ⬆️⬆️⬆️⬆️⬆️⬆️`,
  voltar: "Kembali",
  semDe: "Pemain tanpa tantangan yang terdaftar",
  semDe2: `Daftarkan setidaknya satu tantangan untuk pemain ini 😬. 
    
  Anda akan diarahkan ke layar login.`,
  term: "Privasi",
  Potitic: "Ketentuan Penggunaan",
  adquirited: "Diakuisisi",
  camera: "Kamera",
  galery: "Galeri",
  avatar: "Avatar",
  image: "Gambar",
  seletion: " Terpilih",
  editCategory: "Edit kategori",
  frase1: "Apakah Anda menikmati tantangannya?",
  frase2: "Bagaimana kalau mencoba Premium Challenges?",
  //err texto

  errTexto:
    "Jika Anda menemukan kesalahan penerjemahan, harap perbaiki kalimatnya pada kolom di bawah ini:",
  errTitulo: "Melihat sesuatu yang salah?",
  errCorrect: "Bagaimana seharusnya dalam Bahasa Indonesia?",
  thisLanguageIsCorrect: "Apakah tantangan dalam BAHASA INDONESIA sudah benar?",
  yes: "Iya",
  no: "Tidak",

  errSend: "Kirim saran",
  share: "Bagikan",
  fraseShare: `Aplikasi yang luar biasa! Hanya berbagi karena saya tahu Anda akan menyukainya juga!
Unduh dan kemudian beritahu saya jika itu tidak terlalu bagus lol...😉
  
  
Tautan untuk mengunduh: https://desafiospicantesapp.page.link/share-app`,
  bandeira: "🇮🇩",

  morePlayer: "Bermain dengan lebih banyak pemain?",
  players: "Para pemain",
  carregar: "Unggah Gambar",
  takePhoto: "Mengambil gambar atau memilih gambar",
  useAvatar: "Atau gunakan Avatar",

  hetero: "Pasangan Lurus",
  gay: "Pasangan Gay",
  lesbico: "Pasangan lesbian",

  nomeHomem1: "James",
  nomeHomem2: "George",
  nomeMulher1: "Emily",
  nomeMulher2: "Mia",
  messageErr: "Tambahkan para pemain 🙌",
  descricaoErr: "Masukkan nama-nama peserta ✍️",
  why: "Beritahu kami mengapa...",
  later: "Evaluasi nanti",
  txtCard1: "Giliran Anda 🔥",
  txtCard2: "Wujudkanlah 😘",
  txtCard3: "Ayo pergi! 😜",
  txtCard4: "Tantangan berikutnya 😈",
  txtCard5: "Satu lagi! 👄",

  tituloBloco1Novo: "Jelajahi Keintiman Seksual dengan Pasangan Anda",
  subtitulo1Novo: "Lebih dari 1 juta pasangan bahagia",
  texto1Novo:
    "Jelajahi keintiman antara Anda dan pasangan Anda dan akses permainan terbaik untuk pasangan! Buka sekarang semua game dengan beberapa kategori yang dirancang untuk Anda untuk meningkatkan hubungan dengan pasangan Anda!",

  tituloBloco2Novo: "Pengalaman baru dan hubungan yang lebih baik",
  texto2Novo1: "Nikmati +1500 tantangan",
  texto2Novo2: "Buat tantangan Anda sendiri",
  texto2Novo3: "Kategori eksklusif",
  texto2Novo4: "Tidak ada iklan",
  texto2Novo5: "Avatar Eksklusif",
  texto2Novo6: "Tantangan baru setiap hari",
  texto2Novo7: "Game yang diperbarui secara berkala",
  tituloBloco3Novo: "Peringkat tertinggi dalam kategori",
  tituloBloco4Novo: "Manfaat untuk hubungan Anda:",
  texto4Novo1: "Keintiman",
  texto4Novo2: "Keinginan",
  texto4Novo3: "Ringan",
  texto4Novo4: "Ketertarikan",
  texto4Novo5: "Koneksi",
  texto4Novo6: "Kesenangan",

  tituloBloco5Novo: "Apa yang dikatakan pasangan",
  texto5depoimentoTitulo1: "Blade Moody",
  texto5depoimento1:
    "Saya rasa ini adalah aplikasi terbaik yang saya temukan di ponsel sejauh ini, sangat erotis dan menarik. Semua aplikasi lain yang pernah saya lihat tidak bisa dibandingkan dengan ini, jadi bekerja keraslah dan beli aplikasinya. Jangan mengeluh hanya karena Anda tidak punya uang. Anda melewatkan banyak hal luar biasa di sini, dan hanya dengan $10,00 Anda bisa memiliki seluruh aplikasi. Ini menawarkan pengalaman yang lebih baik daripada permainan yang Anda temukan di toko-toko dewasa lokal.",

  texto5depoimentoTitulo2: "Joon Rxs",
  texto5depoimento2:
    "Aplikasi ini luar biasa! Awalnya saya ragu apakah harus mengunduhnya atau tidak, tetapi ini adalah perasaan terbaik yang kami alami belakangan ini. Sungguh menyenangkan mengetahui bahwa kami masih bisa melakukan banyak hal bersama. 🤭 Kami mencoba versi berbayar dan itu benar-benar sepadan, kami belum pernah mencapai tingkat kenikmatan seperti ini sebelumnya.",

  texto5depoimentoTitulo3: "Monique SantosRader",
  texto5depoimento3:
    "Jika Anda ingin membumbui hubungan Anda, aplikasi ini sempurna! Saya sudah mencoba aplikasi lain, tetapi tidak ada yang memuaskan seperti ini. Foreplay kami jadi jauh lebih panas dan menyenangkan (sekarang bayangkan sisanya!). Benar-benar layak membeli versi berbayar (jika Anda ingin merasakan kenikmatan yang lebih intens), tetapi versi gratisnya juga mengejutkan kami.",

  texto5depoimentoTitulo4: "Anne Owens",
  texto5depoimento4:
    "Luar biasa! Sangat bagus... Kami benar-benar bergairah saat bermain, yang membuat seks menjadi jauh lebih menggairahkan, kenikmatan ada di mana-mana! Kami sudah tidak sabar untuk bermain lagi 💦🔥. Kami juga merekomendasikan versi berbayar jika Anda bisa menangani gairahnya 🤤.",
  tituloBloco6Novo:
    "Lakukan seperti ratusan pasangan di seluruh dunia dan bumbui hubungan Anda.Temukan lebih dari 800 tantangan baru!",
  texto6Select: "Pilih versi:",
  texto6Premium: "Premium",
  texto6Assinatura: "Langganan",
  texto6Mensal: "Bulanan",
  texto6Anual: "Tahunan",
  texto6Vitalicia: "Lisensi seumur hidup",
  bePremium: "Menjadi Premium",
  buyNew: "Beli",
  attention: "Perhatian!",
  changeGender: "Anda telah mengubah orientasi seksual Anda.",
  tituloAvaliacao: "Menikmati permainan ini?",
  textoAvaliacao: "Beri penilaian dan bantu kami untuk terus memperbaiki!",
  agoraNão: "Tidak sekarang",
  enviarAvaliacao: "Kirim",

  nomeJogo1: "Tantangan Nakal",
  nomeJogo2: "Truth Atau Dare?",
  nomeJogo3: "Tingkat Kenakalan",
  nomeJogo4: "Rolet Nakal",
  nomeJogo5: "Frasa Hari Ini",
  naughtyQuiz: "Kuis Nakal",

  playAlone: "Bermain Sendirian",
  estaSozinho: "Sendiri?",
  selectPlayer: "Pilih pemain",

  skip: "Lewati",
  responder: "Kirim",
  respondaAqui: "Jawab di sini",
  config4: "Pilih avatar untuk disesuaikan",

  tituloSelect1: "Bermain sendirian?",
  tituloSelect2: "Jawab pertanyaan yang cukup berani!",

  subTituloSelect1: "Kami akan memberi bantuan!",
  subTituloSelect2: "Temukan seberapa nakal Anda!",
  txtJogador1:
    "Pilih pemain Anda dan jelajahi kesenangan solo terpandu yang dirancang khusus untuk Anda!",
  txtJogador2: "Pemain yang dipilih akan menjawab pertanyaan",
  tituloCena: "ITEM APA YANG INGIN ANDA GUNAKAN?",
  subTituloCena: `Tidak punya? Ketuk "Dapatkan" dan dapatkan dari toko mitra`,
  play: "Bermain",

  titleUserWarning: "Pilih pengguna",
  txtUserWarning: "Pilih pengguna untuk menjawab pertanyaan",

  shareNivelDeSafadeza:
    "Hai, lihat tingkat keusilan saya 😈 Rasakan momen-momen kenikmatan yang intens. Anda juga 💋 Unduh aplikasi sekarang dan siap-siap untuk menikmati tantangan panas 🔥 dengan pasangan Anda: ➡️ https://aplikasitantanganpedas.page.link/sharelevelhot",

  shareDica:
    "Ubah kehidupan cintamu sekarang! Unduh aplikasi dan temukan rahasia hubungan yang pedas: ➡️ https://aplikasitantanganpedas.page.link/tipoftheday",

  resultadoQuiz1:
    "Anda adalah seseorang yang sederhana, tidak terlalu suka hal yang nakal, lebih suka yang lebih romantis!",
  resultadoQuiz2:
    "Anda terlalu romantis untuk terlalu banyak bermain-main, dan lebih menikmati suasana lilin.",
  resultadoQuiz3:
    "Anda adalah orang yang cukup tertutup dan percaya pada menjaga privasi dalam urusan kehidupan pribadi.",
  resultadoQuiz4:
    "Ini bukan berarti Anda tidak nakal kadang-kadang, tetapi Anda lebih suka menyimpan api itu untuk dihabiskan dengan seseorang yang sangat istimewa.",
  resultadoQuiz5:
    "Gairah Anda ada di latar belakang, tapi itu tidak mengubah kenyataan bahwa gairah tersebut tetap ada!",
  resultadoQuiz6:
    "Anda suka menjelajahi pengalaman baru, tetapi selalu dengan hormat dan persetujuan.",
  resultadoQuiz7:
    "Anda menyukai kencan yang panas, penuh dengan ciuman dan keintiman. Namun, ada sisi Anda yang juga suka menonton film sambil bergandengan tangan dengan pasangan atau makan malam romantis dengan lilin.",
  resultadoQuiz8:
    "Anda bersedia mencoba hal-hal baru yang menarik, tetapi selalu dengan tanggung jawab.",
  resultadoQuiz9:
    "Anda adalah orang yang berani dan suka menambahkan sensasi dalam kehidupan pribadi sesekali.",
  resultadoQuiz10:
    "Anda senang menikmati semua kenikmatan dalam hidup, dan tidak ada batasan ketika masalahnya adalah seks.",
  resultadoQuiz11:
    'Dengan Anda, tidak ada waktu yang buruk dan setiap saat adalah waktu yang tepat untuk momen yang intens! Film romantis? Hanya jika itu "50 Shades of Grey"!',
  resultadoQuiz12:
    "Bagi Anda, kedekatan adalah petualangan yang terus-menerus, dan Anda tidak takut mengambil risiko.",
  mes: "Bulan",
  desafiosRestantesDois: "Anda memiliki 2 tantangan Premium tersisa!",
  nenhumDesafioRestante: "Tidak ada tantangan Premium tersisa!",
  tornePremiumAviso1:
    "Jadilah premium sekarang dan nikmati 1000 tantangan Eksklusif!",
  tornePremiumAviso2:
    "Nikmati tantangan tak terbatas, konten eksklusif, dan keseruan tanpa henti!",
  conteudoPremium: "Anda telah memilih konten Premium!",
  aproveite4desafios:
    "Nikmati 4 tantangan premium untuk merasakan kenikmatan eksklusif.",
  calculando: "Menghitung hasil...",
  nivelRomantismo: "Tingkat romantisisme Anda adalah...",
  finalizar: "Selesai",
  erroQuizTitulo: "Masukkan jawaban Anda",
  erroQuizFrase: "Untuk melanjutkan, masukkan jawaban Anda!",
  new: "Aplikasi Baru",

  //resposta quiz safadeza
  resQuiz1: "Lembut",
  resQuiz2: "Penuh Gairah",
  resQuiz3: "Menawan",
  resQuiz4: "Super nakal",

  texto6Semanal: "Mingguan",
  weekly: "Tanda Tangan Mingguan",
  tempSemanal: "Ditagih mingguan",
  tempMensal: "Ditagih bulanan",
  tempAnual: "Ditagih tahunan",
  tempSempre: "Pembayaran sekali",
  canceleAny: "Batal kapan saja",

  //Tela do safadrometro
  Low: "Rendah",
  Medium: "Sedang",
  High: "Tinggi",
  lifeTime: "Akses seumur hidup",
  notNow: "Tidak sekarang, terima kasih",
  match: "COCOK DENGAN A.I.",

  //Modal date
  dateTitle: "Ingin mencoba aplikasi baru kami?",

  dateBody: `Ingin mengobrol dengan bot nakal 😈 dan berlatih merayu? Anda akan bersenang-senang!🔥`,
  goToDate: "Coba Date.AI Sekarang!",

  goodForU: "APAKAH ITU BAGUS UNTUK ANDA?",
  rateOurPerformance: "Nilai kinerja kami sejauh ini",
  veryGood: "Sangat Baik",
  veryBad: "Sangat Buruk",
  feedbackChallenge: `Apa yang akan membuat Anda berbagi aplikasi Hot Challenges dengan pasangan lain dan mengapa?`,
  type: "Ketik jawaban Anda di sini...",
  survey: "Survei kepuasan.",
  shareIfConfortable: `Jangan ragu untuk berbagi dengan teman-teman jika Anda merasa nyaman :)`,

  howToPlay: "Cara Bermain",
  howToPlayHotChallenge:
    "Bersiaplah untuk meningkatkan gairah! Ambil kartu tantangan dan kejutan pasangan Anda dengan aksi panas!",

  preGameTip1:
    "Bebaskan hasrat Anda dan ciptakan momen tak terlupakan dengan pasangan Anda!",
  preGameTip2:
    "Nyalakan gairah Anda dan ciptakan momen tak terlupakan bersama!",
  preGameTip3:
    "Jelajahi hasrat terliarmu dan ciptakan kenangan yang tak terlupakan!",
  preGameTip4:
    "Bebaskan fantasi Anda dan nikmati momen penuh kenikmatan murni!",
  selecionajoagador: "Waktunya bermain",
  dica: "Petunjuk",
  howToPlayNaughty:
    "Pilih mainan dan objek favorit Anda. Putar roda dan biarkan takdir menentukan tantangan nakal Anda berikutnya!",
  howToPlayTruthOrDare:
    "Pilih takdirmu: bagikan kebenaran atau terima tantangan berani. Biarkan kesenangan dimulai!",
  howToKama1: "Temukan Posisi Kenikmatan – 365 Hari Penuh Gairah!",
  howToKama2:
    "Pilih kartu acak, coba posisinya, dan jelajahi puncak kenikmatan baru bersama!",
  kamaExplain:
    "Buka posisi baru setiap hari dan bangun koleksi gairah terbaikmu – perjalanan 365 hari kenikmatan tak terlupakan dimulai di sini!",
  howToDo: "Cara melakukannya",
  pergunta: "Pertanyaan",
  restart: "Mulai Ulang",
  dialogText1HotChallenges:
    "Anda telah menyelesaikan semua tantangan yang tersedia dengan kategori yang dipilih.",
  dialogText2HotChallenges:
    "Pilih lebih banyak kategori atau mulai ulang permainan dengan tantangan saat ini!",
  noChallenges: "Tidak Ada Tantangan!",

  objects: "Objek",
  dialogText1NaughtyGames:
    "Anda telah menyelesaikan semua tantangan yang tersedia dengan objek yang dipilih.",
  dialogText2NaughtyGames:
    "Pilih lebih banyak objek atau mulai ulang permainan dengan tantangan saat ini!",
  unlockPremium: "Buka Premium",
  noCategory: "Silakan pilih setidaknya satu kategori untuk memulai.",
  thanksForFeedback:
    "Terima kasih telah membantu kami meningkatkan pengalaman!",
  categoryKamasutra: "Pilih gairahmu dan bermain!",
  tap: "Ketuk untuk mengungkap posisimu!",
  step: "Panduan Langkah demi Langkah",
  shareQuizButton: "Bagikan tingkat kenakalanmu!",
  tryAgain: "Coba lagi",
  unlockAllFun: "Buka semua kesenangan",
  limitedOffer: "Penawaran spesial untuk waktu terbatas!",
  fill: "Masukkan nama Anda dan nama pasangan Anda.",
  kamaNotificationTitle: "🔥 Kartu baru Anda telah terbuka!",
  kamaNotificationBody:
    "Posisi hari ke-{variavel} Anda sudah siap. Bagaimana kalau mencoba sesuatu yang baru hari ini? 💋",

  titleNewGame: "Bersiaplah untuk Roleplay!",
  phraseNewGame:
    "Dalam pembaruan berikutnya, permainan baru untuk mengeksplorasi fantasi paling kreatif Anda akan hadir. Pilih karakter, ciptakan cerita, dan tingkatkan kesenangan ke level baru bersama pasangan Anda. 🔥",
  awaitNewGame: "Tunggu dan bersiaplah untuk momen-momen istimewa!",

  selectObjects:
    "Pilih dua atau lebih item untuk menyesuaikan permainan Anda. Jelajahi semaksimal mungkin.",
  soon: "Segera",
  wantToBeNotify: "Saya ingin diberi tahu",
  ok: "OK",
  vezDe: "GILIRAN",

  categoryLabel: "Kategori",
  descriptionLabel: "Deskripsi",

  loginConnect: "Masuk",
  loginNoAccount: "Tidak punya akun?",
  loginCreateNow: "Buat sekarang",
  loginOrConnect: "atau masuk dengan",

  email: "Email",
  password: "Kata Sandi",
  loginRegister: "Daftar",
  loginAlreadyHas: "Sudah punya akun?",
  enterNow: "Masuk Sekarang",

  logout: "Keluar",
  customerPortal: "Portal Pelanggan",
  installApp: "Instal Aplikasi",
  loginVideo:
    "https://desafios-picantes-bucket.dev12br.com/videos-login/indonesio.mp4",
};
